import { useEffect, useState } from "react";
import StudentStats from "./StudentStats";
import StudentsTable from "./StudentsTable";
import StudentModal from "./StudentModal";
import { getStudentsList } from "../../services/studentService";
import { useUser } from "../../context/AuthContext";
import "./ManageStudents.css";

const ManageStudents = () => {
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const { user } = useUser();

  // ✅ Extract defaults (first group & course)
  const groupId = user?.data?.Groups?.[0]?.GroupId;
  const courseId =
    user?.data?.Groups?.[0]?.Branches?.[0]?.Courses?.[0]?.CourseId;

  const loadStudents = async () => {
    if (!groupId || !courseId) return;

    try {
      setLoading(true);

      const payload = {
        GroupId: groupId,
        //CourseId: courseId,
      };

      console.log("Students Payload 👉", payload);

      const res = await getStudentsList(payload);

      console.log("Students Response ✅", res);

      setStudents(res || []);
    } catch (err) {
      console.error("Students API Error ❌", err);
      setStudents([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStudents();
  }, [groupId, courseId]);

  return (
    <div className="manage-students-page">
      {/* HEADER */}
      <div className="page-header">
        <div className="page-title-wrap">
          <h2>Manage Students</h2>
        </div>

        <button
          className="primary-btn"
          onClick={() => {
            setEditData(null);
            setShowModal(true);
          }}
        >
          + Add Student
        </button>
      </div>


      <StudentStats students={students} />

      <StudentsTable
        data={students}
        loading={loading}
        onEdit={(row) => {
          setEditData(row);
          setOpen(true);
        }}
      />

      {showModal && (
        <StudentModal
          data={editData}
          onClose={() => setShowModal(false)}
        />
      )} 
    </div>
  );
};

export default ManageStudents;
